import React from 'react';
import { connect } from 'react-redux';
import objectPath from 'object-path';
import * as builder from '../../ducks/builder';
import TermDialog from '../../../app/components/other/Dialog/TermDialog';
import { LayoutContextConsumer } from '../LayoutContext';
import {FormattedMessage, injectIntl} from 'react-intl';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      dialogContentType: '',
    };
  }

  handleDialogOpen = contentType => {
    this.setState({
      dialogContentType: contentType,
      openDialog: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      openDialog: false,
    });
  };
  render() {
    // const today = new Date().getFullYear();
    const { intl, userRole } = this.props;
    const { openDialog, dialogContentType } = this.state;
    const isAdmin = userRole === 'ROLE_ADMIN';
    return (
      <LayoutContextConsumer>
        {({ footer: { show } }) =>
          show && (
            <div
              className={`kt-footer ${this.props.footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`}
              id='kt_footer'
            >
              <div className={`kt-container ${this.props.footerContainerClasses}`}>
                <div className='kt-footer__copyright'>
                  <div style={{maxWidth:800}}>
                    <a
                      href='https://start-mobile.net'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='kt-link'
                    >
                      {intl.formatMessage({ id: 'AUTH.CREATOR.COMPANY' })}
                    </a>
                    <br />
                    <a
                      rel='noopener noreferrer'
                      className='kt-link'
                      href={'/documents/legacy/read'}
                      // onClick={() => this.handleDialogOpen('user_agreement')}
                    >
                      <FormattedMessage id='SUBMENU.LEGAL_TERMS' />
                    </a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <a
                      href={'/documents/privacy/read'}
                      // onClick={() => this.handleDialogOpen('privacy_policy')}
                      rel='noopener noreferrer'
                      className='kt-link'
                    >
                      <FormattedMessage id='SUBMENU.LEGAL_PRIVACY' />
                    </a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <a
                      href={'/documents/shipping/read'}
                      rel='noopener noreferrer'
                      className='kt-link'
                    >
                      <FormattedMessage id='SUBMENU.SHIPPING' />
                    </a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <a
                      href={'/documents/refund/read'}
                      // onClick={() => this.handleDialogOpen('refund_policy')}
                      rel='noopener noreferrer'
                      className='kt-link'
                    >
                      <FormattedMessage id='SUBMENU.REFUND' />
                    </a>
                    {
                      // isAdmin &&
                      (<>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <a
                      href={'/documents/developers/read'}
                      // onClick={() => this.handleDialogOpen('refund_policy')}
                      rel='noopener noreferrer'
                      className='kt-link'
                      >
                        {intl.formatMessage({id: 'SUBMENU.DEVELOPERS'})}
                      </a>
                      </>)
                    }
                    {
                      // isAdmin &&
                      (<>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                          href={'/documents/furniture_manufacturers/read'}
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                        >
                          {intl.formatMessage({ id: 'SUBMENU.FURNITURE' })}
                        </a>
                      </>)
                    }
                    {
                      // isAdmin &&
                      (<>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                          href={'/documents/interior_designers/read'}
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                        >
                          {intl.formatMessage({ id: 'SUBMENU.DESIGNER.INT' })}
                        </a>
                      </>)
                    }
                    {
                      // isAdmin &&
                      (<>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                          href={'/documents/manufacturers_finishing_materials/read'}
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                        >
                          {intl.formatMessage({ id: 'SUBMENU.MATERIALS' })}
                        </a>
                      </>)
                    }
                    {
                      // isAdmin &&
                      (<>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                          href={'/documents/realtors/read'}
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                        >
                          {intl.formatMessage({ id: 'SUBMENU.REALTORS' })}
                        </a>
                      </>)
                    }
                    {
                      // isAdmin &&
                      (<>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a
                          href={'/documents/repair_organizations/read'}
                          // onClick={() => this.handleDialogOpen('refund_policy')}
                          rel='noopener noreferrer'
                          className='kt-link'
                        >
                          {intl.formatMessage({ id: 'SUBMENU.ORGANIZATIONS' })}
                        </a>
                      </>)
                    }
                  </div>
                  {/*<div className='kt-footer__menu'></div>*/}
                  <>
                    <TermDialog
                      isOpen={openDialog}
                      handleClose={this.handleDialogClose}
                      contentType={dialogContentType}
                    />
                  </>
                </div>
              </div>
            </div>
          )
        }
      </LayoutContextConsumer>
    );
  }
}

const mapStateToProps = store => ({
  fluid: objectPath.get(store.builder.layoutConfig, 'footer.self.width') === 'fluid',
  footerClasses: builder.selectors.getClasses(store, {
    path: 'footer',
    toString: true,
  }),
  footerContainerClasses: builder.selectors.getClasses(store, {
    path: 'footer_container',
    toString: true,
  }),
});

export default connect(mapStateToProps)(injectIntl(Footer));
